const AdreadRoutes = {
  getAllAdreads: "/admin/getallblogs",
  createAdread: "/blog/blog",
  updateAdread: "/blog/updateblogs"
}

export default AdreadRoutes;